<template>
  <div>
    <HeaderKuesioner />
    <section class="service-wrapper py-5">
      <div class="container">
        <div class="bg-line"></div>
        <div class="row mt-5">
          <div class="col-12 border-bottom px-4 py-2">
            <div class="row d-flex justify-content-center">
              <div class="col-md-12">
                <h2 class="h2 text-left col-12 mb-3 mt-3 ml-4" style="color: #010D4A;">
                  Verifikasi
                </h2>
                <form @submit.prevent="handleVerifikasi" class="px-5 py-5">
                  <div v-if="message" class="alert alert-danger rounded mb-5" role="alert">
                    {{ message }}
                  </div>
                  <div class="row">
                    <div class="forms-inputs col-12 mb-4">
                      <span>NPM</span><input v-model="alumni.npm" v-validate="'required'" type="number"
                        class="form-control" name="npm" />
                    </div>
                  </div>
                  <div v-if="errors.has('npm')" class="alert alert-danger rounded mb-5" role="alert">
                    NPM wajib diisi!
                  </div>

                  <div class="row">
                    <div class="forms-inputs col-12 mb-4">
                      <span>Tgl Lahir</span><input v-model="alumni.tgl_lahir" v-validate="'required'" type="date"
                        class="form-control" name="tgl_lahir" />
                    </div>
                  </div>
                  <div v-if="errors.has('tgl_lahir')" class="alert alert-danger rounded mb-5" role="alert">
                    Tgl lahir wajib diisi!
                  </div>

                  <div class="row d-flex justify-content-center text-right mb-5 mt-3">
                    <div class="col-lg-12 col-12">
                      <div v-show="loading">
                        <Loading />
                      </div>
                      <button class="button-secondary custom_2">
                        Berikutnya
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import Loading from "@/components/Loading.vue";
import Alumni from "@/models/alumni";
import SurveyService from "@/services/survey.service";

export default {
  name: "Verifikasi",
  components: {
    HeaderKuesioner,
    Loading
  },
  data() {
    return {
      alumni: new Alumni(""),
      loading: false,
      message: "",
      survey_id: this.$route.params.id
    };
  },
  computed: {
    currentAlumni() {
      return this.$store.state.survey.alumni.data;
    }
  },
  created() {
    if (this.currentAlumni) {
      this.$router.push({ name: "alumni-dashboard" });
    }
  },
  mounted() {
    this.getSurvey();
  },
  methods: {
    getSurvey() {
      SurveyService.showSurvey(this.survey_id)
        .then(res => {
          this.survey = res.data.survey;
          this.$store.dispatch("survey/dataSurvey", this.survey);
        })
        .catch(error => console.error(error));
    },
    handleVerifikasi() {
      this.loading = true;
      this.$store.commit("SHOW_LOADING", "Memverifikasi data...");
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          this.$store.commit("HIDE_LOADING");
          return;
        }
        if (this.alumni.npm && this.alumni.tgl_lahir) {
          this.$store.dispatch("survey/cekAlumni", this.alumni).then(
            () => {
              this.$store.commit("HIDE_LOADING");
              this.$router.push("/alumni/dashboard");
            },
            error => {
              this.loading = false;
              this.$store.commit("HIDE_LOADING");
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  margin: 20px auto;
  padding: 0;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  font-family: "Glegoo", sans-serif;
  font-size: 0.8rem;
  line-height: normal;
}

.bg-line {
    background-color: #003E29;
    height: 10px;
    margin-bottom: 20px
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #010d4a;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

@media only screen and (max-width: 480px) {
  .forms-inputs input {
    height: 70px;
    font-size: 0.8rem;
  }

  .forms-inputs select {
    height: 70px;
    font-size: 0.8rem;
  }

  .forms-inputs span {
    font-size: 0.9rem;
  }
}
</style>
